import { Collection } from 'modules/core/lib/mobx-rest'

import CompanyValue from 'modules/company_page/store/models/CompanyValue'

export class CompanyValues extends Collection<CompanyValue> {
  get cacheKey(): string {
    return 'companyValues'
  }

  model() {
    return CompanyValue
  }
}

export default new CompanyValues()
